export default [
    {
        path: 'procedimento-cirurgico',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-procedimento-cirurgico' */
            '@/views/parametrizacao/procedimento-cirurgico/Index'
        ),
        redirect: 'procedimento-cirurgico/index',
        children: [
            {
                name: 'parametrizacao-procedimento-cirurgico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento-cirurgico' */
                    '@/views/parametrizacao/procedimento-cirurgico/List.vue'
                ),
            },
            {
                name: 'parametrizacao-procedimento-cirurgico-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento-cirurgico' */
                    '@/views/parametrizacao/procedimento-cirurgico/Form.vue'
                ),
            },
            {
                name: 'parametrizacao-procedimento-cirurgico-edit',
                path: 'edit/:id',
                props: route => {
                    return { id: parseInt(route.params.id) };
                  },
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento-cirurgico' */
                    '@/views/parametrizacao/procedimento-cirurgico/Form.vue'
                ),
            },
        ],
    },
]